import {
    CREATE_BILL_PAYMENT_MASTER_REQUEST,
    CREATE_BILL_PAYMENT_MASTER_SUCCESS,
    CREATE_BILL_PAYMENT_MASTER_FAILURE,
    DELETE_BILL_PAYMENT_MASTER_REQUEST,
    DELETE_BILL_PAYMENT_MASTER_SUCCESS,
    DELETE_BILL_PAYMENT_MASTER_FAILURE,
    FETCH_SINGLE_BILL_PAYMENT_MASTER_REQUEST,
    FETCH_SINGLE_BILL_PAYMENT_MASTER_SUCCESS,
    FETCH_SINGLE_BILL_PAYMENT_MASTER_FAILURE,
    FETCH_BILL_PAYMENT_MASTER_REQUEST,
    FETCH_BILL_PAYMENT_MASTER_SUCCESS,
    FETCH_BILL_PAYMENT_MASTER_FAILURE,
    UPDATE_BILL_PAYMENT_MASTER_REQUEST,
    UPDATE_BILL_PAYMENT_MASTER_SUCCESS,
    UPDATE_BILL_PAYMENT_MASTER_FAILURE,
    RESET_BILL_PAYMENT_MASTER_INFO,
    CREATE_BILL_PAYMENT_MASTER_FORM,
    UPDATE_BILL_PAYMENT_MASTER_FORM,
    NAVIGATE_BILL_PAYMENT_DETAILS,
    NAVIGATE_BILL_PAYMENT_MASTER,
    GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_REQUEST,
    GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_SUCCESS,
    GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_FAILURE,
    FETCH_PENDING_BILL_PAYMENT_MASTER_REQUEST,
    FETCH_PENDING_BILL_PAYMENT_MASTER_SUCCESS,
    FETCH_PENDING_BILL_PAYMENT_MASTER_FAILURE,
    CREATE_MULTIPLE_BILL_PAYMENT_REQUEST,
    CREATE_MULTIPLE_BILL_PAYMENT_SUCCESS,
    CREATE_MULTIPLE_BILL_PAYMENT_FAILURE,
    SET_ACTIVE_KEY_BILL_PAYMENT_INWARD_DK,
    RESET_FORM_DATA_WITHOUT_INWARD_ID_DK,
    FETCH_BILL_PAYMENT_SUPPLIER_MASTER_REQUEST,
    FETCH_BILL_PAYMENT_SUPPLIER_MASTER_SUCCESS,
    FETCH_BILL_PAYMENT_SUPPLIER_MASTER_FAILURE
} from './billPaymentHeader.actionsType';

export const BILL_PAYMENT_MASTER = 'billPayment';

let initialState = {
    loading: false,
    billPayment: [],
    paymentByContractor: [],
    pendingBillPaymentsList: [],
    billPaymentsSupplierWiseList: [],
    billPaymentForm: {
        fldIsTCSApplicable: false,
        fldIsTDSApplicable: false,
        fldIsPaymentDone: false,
        fldTDSPercentage: 0,
        fldTDSValue: '',
        fldTCSPercentage: 0,
        fldTCSValue: '',
        fldAmountPayable: 0,
        fldFKBank: 0,
        fldChequeNo: 0,
        fldTransactionNo: 0,
        fldPayableDate: null,
        fldTotalAmount: ''
    },
    selectedState: {},
    pimInwardId: [],
    activeKey: 1,
    errorMessage: '',
    singleBillPayment: {},
    isBillPaymentDetails: false
};

export let billPaymentMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_PAYMENT_MASTER_REQUEST:
        case FETCH_PENDING_BILL_PAYMENT_MASTER_REQUEST:
        case GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_REQUEST:
        case CREATE_BILL_PAYMENT_MASTER_REQUEST:
        case CREATE_MULTIPLE_BILL_PAYMENT_REQUEST:
        case UPDATE_BILL_PAYMENT_MASTER_REQUEST:
        case FETCH_SINGLE_BILL_PAYMENT_MASTER_REQUEST:
        case FETCH_BILL_PAYMENT_SUPPLIER_MASTER_REQUEST:
        case DELETE_BILL_PAYMENT_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPayment: updatePayload
            };
        case FETCH_BILL_PAYMENT_SUPPLIER_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentsSupplierWiseList: updatePayload
            };
        case FETCH_PENDING_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingBillPaymentsList: updatePayload
            };
        case GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false
                // paymentByContractor: updatePayload
            };
        case CREATE_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                },
                pimInwardId: updatePayload,
                activeKey: updatePayload[0]?.fldId && payload == true ? 2 : 1
            };
        case SET_ACTIVE_KEY_BILL_PAYMENT_INWARD_DK:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case CREATE_MULTIPLE_BILL_PAYMENT_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                },
                billPaymentsSupplierWiseList: []
            };
        case UPDATE_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                }
            };
        case FETCH_SINGLE_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    ...updatePayload,
                    fldBillPaymentDate: updatePayload?.fldBillPaymentDate && updatePayload?.fldBillPaymentDate.split('T')[0],
                    fldPayableDate: updatePayload?.fldPayableDate && updatePayload?.fldPayableDate.split('T')[0]
                }
            };
        case DELETE_BILL_PAYMENT_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                }
            };
        case RESET_BILL_PAYMENT_MASTER_INFO:
            return {
                ...state,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                },
                pimInwardId: [],
                billPaymentsSupplierWiseList: []
            };
        case CREATE_BILL_PAYMENT_MASTER_FORM:
        case UPDATE_BILL_PAYMENT_MASTER_FORM:
            return {
                ...state,
                loading: false,
                billPaymentForm: {
                    ...state.billPaymentForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_BILL_PAYMENT_MASTER_FAILURE:
        case FETCH_PENDING_BILL_PAYMENT_MASTER_FAILURE:
        case GENERATE_MULTIPLE_BILL_PAYMENT_MASTER_FAILURE:
        case CREATE_BILL_PAYMENT_MASTER_FAILURE:
        case CREATE_MULTIPLE_BILL_PAYMENT_FAILURE:
        case UPDATE_BILL_PAYMENT_MASTER_FAILURE:
        case FETCH_SINGLE_BILL_PAYMENT_MASTER_FAILURE:
        case FETCH_BILL_PAYMENT_SUPPLIER_MASTER_FAILURE:
        case DELETE_BILL_PAYMENT_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case RESET_FORM_DATA_WITHOUT_INWARD_ID_DK:
            return {
                ...state,
                billPaymentForm: {
                    fldIsTCSApplicable: false,
                    fldIsTDSApplicable: false,
                    fldIsPaymentDone: false,
                    fldTDSPercentage: 0,
                    fldTDSValue: '',
                    fldTCSPercentage: 0,
                    fldTCSValue: '',
                    fldAmountPayable: 0,
                    fldFKBank: 0,
                    fldChequeNo: 0,
                    fldTransactionNo: 0,
                    fldPayableDate: null,
                    fldTotalAmount: ''
                },
                selectedTeam: {},
                billPaymentsSupplierWiseList: []
            };
        case NAVIGATE_BILL_PAYMENT_DETAILS:
            return {
                ...state,
                isBillPaymentDetails: true,
                singleBillPayment: updatePayload.singleBillPayment
            };
        case NAVIGATE_BILL_PAYMENT_MASTER:
            return {
                ...state,
                isBillPaymentDetails: false
            };
        default:
            return state;
    }
};
